import { NavLink } from "react-router-dom";
import { Users, CalendarDays, CalendarOff } from "lucide-react";

const TABS = [
  { to: "/employes", label: "Fiches", icon: Users, end: true },
  { to: "/employes/planning", label: "Planning", icon: CalendarDays },
  { to: "/employes/absences", label: "Absences", icon: CalendarOff },
];

export const EmployeesTabs = () => (
  <div className="grid grid-cols-3 sm:flex gap-1 bg-slate-100 p-1 rounded-lg sm:w-fit mb-5" data-testid="employees-tabs">
    {TABS.map(({ to, label, icon: Icon, end }) => (
      <NavLink
        key={to}
        to={to}
        end={end}
        data-testid={`emp-tab-${label.toLowerCase()}`}
        className={({ isActive }) =>
          `flex min-w-0 min-h-11 items-center justify-center gap-1.5 px-2 sm:px-4 py-1.5 rounded-md text-xs sm:text-sm font-medium transition-colors ${
            isActive ? "bg-white text-[#26788A] shadow-sm" : "text-slate-600 hover:text-slate-900"
          }`
        }
      >
        <Icon size={15} /> {label}
      </NavLink>
    ))}
  </div>
);
